<script setup lang="ts">
import { computed, inject } from 'vue'
import type { InputGroupButtonProps } from '.'
import { Button } from '@ds/primitives/button'
import { INPUT_GROUP_SIZE } from '.'

const props = withDefaults(defineProps<InputGroupButtonProps>(), {
  variant: 'ghost',
})

const groupSize = inject(INPUT_GROUP_SIZE)

// Same three-step scale as `DSButton`'s own icon sizes, one notch down so the
// button sits inside the group's border rather than filling it edge to edge.
const buttonSize = computed(() => {
  switch (props.size ?? groupSize?.value ?? 'md') {
    case 'sm':
      return 'icon-sm'
    case 'lg':
      return 'icon-lg'
    default:
      return 'icon'
  }
})
</script>

<template>
  <Button
    :variant="props.variant"
    :size="buttonSize"
    :class="props.class"
  >
    <slot />
  </Button>
</template>
